import React from "react"
import { injectIntl } from "gatsby-plugin-intl"
import {
  FundraiseHero,
  FundraiseInfo,
  FundraiseJoinAsCorporate,
} from "@tmu/components/fundraise"
import { BlogCareerSection } from "@tmu/components/common"
import SEO from "@tmu/components/seo"
import { StyledPageContainer } from "@tmu/global/page-addons/fundraise-page.styles"
import tableItImage from "../../assets/images/table_it.png"
import tableEnImage from "../../assets/images/table_en.png"
import tableEsImage from "../../assets/images/table_es.png"

const FundraisePage = ({ intl }) => {
  const { locale, formatMessage } = intl

  return (
    <>
      <SEO
        lang={locale}
        title={formatMessage({
          id: "fundraise::common::pageTitle",
          defaultMessage: "Become a Fundraiser",
        })}
        description={formatMessage({
          id: "seo::fundraise::description",
          defaultMessage:
            "Support your favorite charities by creating your campaign.",
        })}
      />
      <StyledPageContainer>
        <FundraiseHero />
        <FundraiseInfo />
        <img
          src={
            locale === "es"
              ? tableEsImage
              : locale === "en"
              ? tableEnImage
              : tableItImage
          }
          alt="Table"
          style={{
            width: "100%",
            maxWidth: "100%",
            height: "auto",
            margin: "1rem 0",
            padding: "0 1rem",
          }}
        />
        <FundraiseJoinAsCorporate />
        <BlogCareerSection />
      </StyledPageContainer>
    </>
  )
}

export default injectIntl(FundraisePage)
